import { AfterViewInit, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ToastComponent, ToastModule } from '@syncfusion/ej2-angular-notifications';
import { ToastService } from './shared/service/toast.service';

import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { HomeComponent } from './home/home.component';
import { AuthService } from '@auth0/auth0-angular';
import { IndexedDBService } from './shared/service/indexed-db.service';

@Component({
  selector: 'ocado-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  standalone: true,
  imports: [ ToastModule, RouterModule, HomeComponent, FormsModule ],
})
export class AppComponent implements OnInit, AfterViewInit, OnDestroy {

  title = 'promo-ui';
  @ViewChild(ToastComponent) private toast!: ToastComponent;
  user: any;

  constructor(private toastService: ToastService, public auth: AuthService, private indexedDbService: IndexedDBService) {
    this.indexedDbService.initDB();
  }

  ngOnInit(): void {
    this.auth.user$.subscribe((userDetails: any) => {
      this.user = userDetails;
      this.identifyUserWithHelpScout(this.user);
    });

  }
  identifyUserWithHelpScout(user: any): void {
    if ((window as any)[ 'identifyUserWithHelpScout' ]) {
      (window as any)[ 'identifyUserWithHelpScout' ](user);
    }
  }

  ngAfterViewInit(): void {
    this.toastService.toast = this.toast;
  }

  ngOnDestroy(): void {
    this.toast?.destroy();
  }

}